<template>
  <div :class="$style.addPhone">
    <SelectField
      :validator="formValidator"
      :field="`phones.${index}.phoneType`"
      v-model="phone.phoneType"
      :options="phoneTypes"
      autocomplete="nope"
      placeholder=""/>
    <!--<InputField-->
    <!--:validator="formValidator"-->
    <!--:field="`phones.${index}.phoneType`"-->
    <!--v-model="phone.phoneType"-->
    <!--autocomplete="nope"-->
    <!--placeholder=""/>-->
    <InputField
      :validator="formValidator"
      :field="`phones.${index}.phoneNumber`"
      :autocomplete="'tel'"
      v-model="phone.phoneNumber"
      placeholder=""/>
    <div
      :class="$style.deleteBtn"
      @click="removeNumber">
      <IconDelete :class="$style.deleteIcon"
                  :accent="accent"/>
    </div>

  </div>
</template>

<script>
/* Vue Components */
import IconDelete from 'src/components/icons/Icon.Delete.vue';
import InputField from 'src/components/formFields/FormField.Input.vue';
import SelectField from 'src/components/formFields/FormField.Select.vue';
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */
import phoneTypes from '../../data/phoneTypes';

export default {
  name: 'NewPhone',
  components: {
    IconDelete,
    InputField,
    SelectField,
  },
  props: {
    phone: {
      type: Object,
      required: true,
    },
    accent: {
      type: String,
      default: '#eea417',
    },
    formValidator: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      phoneTypes,
    }
  },
  methods: {
    removeNumber() {
      this.$emit('remove', this.index);
    },
  },
};
</script>
<style lang="scss"
       module>
@import "src/brand/brandColors.variables";

.addPhone {
  display: flex;
  flex-flow: row wrap;
  position: relative;
}

.deleteBtn {
  position: absolute;
  left: -6.4rem;
  width: 4rem;
  height: 4rem;
  top: .5rem;
  background-color: $gray-light;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.deleteIcon {
  width: 1.5rem;
  height: 1.5rem;
}
</style>
